/*@ngInject*/
const AttachmentRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.retrieveAttachment = function (attachmentId) {
        let url = '/rest/UnderwritingAttachment/' + attachmentId;

        return this.get(url);
    };
};

angular.module('umCore')
    .service('attachmentRepository', AttachmentRepository);
